// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as MinimizeComponent} from './Minimize.svg';

import Icon, { TIconProps } from '../Icon';

export const IconMinimize = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <MinimizeComponent/>
  </Icon>
));
